<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <scoring-coverage-filters
          :hasFiltersApplied="someCoverageFiltersApplied"
          :countFiltersSelected="countCoverageFiltersApplied"
          :issuersFilter="getCoverageFilters.issuers"
          :issuerOptions="getCoverageIssuersList"
          @reset-coverage-filters="resetScoringCoverageFilters"
          @on-apply-filters="onApplyFilters"
          @update:searchBar="filterByString"
          :isProfileEditing="true"
          :searchBar="searchBar"
        ></scoring-coverage-filters>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col v-if="!productsFound">
        <no-content
          :icon-name="'exclamation-circle'"
          :icon-class="['mb-3', 'fa-3x']"
          :text="$t('common.noScoringProfilesFound')"
        ></no-content>
      </b-col>
      <b-col v-else>
        <div class="mt-3">
          <scoring-coverage-card
            v-if="getFilteredIncludedProducts.length > 0"
            :tableItems="getFilteredIncludedProducts"
            :productsFoundLabel="getIncludeCardProductsFoundLabel"
            :labelValue="getIncludeCardLabel"
            :tooltipValue="$t('scoringProfileDetails.covrageDetailIncludedTooltip')"
            is-include-card
            @on-click-table-row="onClickTableRow"
            @on-exclude-click="excludeProducts"
          >
          </scoring-coverage-card>
        </div>
        <div class="mt-3" v-if="getFilteredExcludedProducts.length > 0">
          <scoring-coverage-card
            :tableItems="getFilteredExcludedProducts"
            :productsFoundLabel="getExcludeCardProductsFoundLabel"
            :labelValue="getExcludeCardLabel"
            :tooltipValue="$t('scoringProfileDetails.coverageDetailExcludedTooltip')"
            @on-click-table-row="onClickTableRow"
            @on-include-click="includeProducts"
          >
          </scoring-coverage-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ScoringCoverageFilters from '../../components/ScoringProfiles/ScoringCoverageFilters.vue'
import ScoringCoverageCard from '../../components/ScoringProfiles/ScoringCoverageCard.vue'
import NoContent from '../../components/Lib/NoContent'
import { INIT_COVERAGE_FILTERS_EDIT } from '../../settings/scoringProfilesSettings'
import { deepDiffMapper, VALUE_CHANGED } from '../../utils/objDifference'
import { cloneObject } from '../../imports/lib'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('scoringProfilesCoverageDetail')

export default {
  components: {
    ScoringCoverageFilters,
    NoContent,
    ScoringCoverageCard,
  },
  data() {
    return {
      issuerList: {},
      searchBar: '',
    }
  },
  computed: {
    ...mapGetters([
      'getFilteredIncludedProducts',
      'getCoverageIssuersList',
      'getFilteredExcludedProducts',
      'getCoverageFilters',
      'getCoverageProductsList',
      'getIncludedProductsNumber',
      'getExcludedProductsNumber',
    ]),
    someCoverageFiltersApplied() {
      return this.countCoverageFiltersApplied > 0
    },
    countCoverageFiltersApplied() {
      const defaultFilters = INIT_COVERAGE_FILTERS_EDIT()
      const appliedFilters = cloneObject(this.getCoverageFilters)

      delete appliedFilters.queryString

      const diff = deepDiffMapper(appliedFilters, defaultFilters).filterByType(VALUE_CHANGED).result
      //any field pairs as xxxF and xxxT count as 1
      const values = Object.keys(diff).filter(
        (key) => !(key.endsWith('F') && Object.keys(diff).includes(key.slice(0, -1) + 'T'))
      )

      let filtersApplied = values.length

      if (this.searchBar !== '') {
        filtersApplied = filtersApplied + 1
      }

      return filtersApplied
    },
    productsFound() {
      return this.getFilteredExcludedProducts.length > 0 || this.getFilteredIncludedProducts.length > 0
    },
    getIncludeCardProductsFoundLabel() {
      return this.someCoverageFiltersApplied
        ? this.$tc('scoringProfileDetails.productsFound', this.getFilteredIncludedProducts.length)
        : this.$tc('search.label.includedProducts', this.getFilteredIncludedProducts.length)
    },
    getIncludeCardLabel() {
      return this.someCoverageFiltersApplied
        ? this.$tc('scoringProfileDetails.totalIncluded', this.getIncludedProductsNumber)
        : this.$t('search.label.inRange')
    },
    getExcludeCardProductsFoundLabel() {
      return this.someCoverageFiltersApplied
        ? this.$tc('scoringProfileDetails.productsFound', this.getFilteredExcludedProducts.length)
        : this.$tc('search.label.excludedProducts', this.getFilteredExcludedProducts.length)
    },
    getExcludeCardLabel() {
      return this.someCoverageFiltersApplied
        ? this.$tc('scoringProfileDetails.totalExcluded', this.getExcludedProductsNumber)
        : this.$t('search.label.fromRange')
    },
  },
  methods: {
    ...mapActions([
      'includeCoverageProducts',
      'excludeCoverageProducts',
      'searchProducts',
      'setCoverageFilters',
      'resetCoverageFilters',
    ]),
    filterByString(value) {
      this.searchBar = value
      const filters = {
        ...this.getCoverageFilters,
        queryString: value,
      }
      this.setCoverageFilters(filters)
      this.searchProducts()
    },
    onApplyFilters(value) {
      const coverageFilters = value
      const filters = {
        queryString: this.searchBar,
        ...coverageFilters,
      }
      this.setCoverageFilters(filters)
      this.searchProducts()
    },
    onClickTableRow(value) {
      this.openProductDetails(value, this.$store.getters['scoringProfilesCommon/getScoringProfileId'])
    },
    resetScoringCoverageFilters() {
      this.searchBar = ''
      this.resetCoverageFilters()
      this.searchProducts()
    },
    includeProducts(products) {
      this.includeCoverageProducts({ products })
      this.searchProducts()
    },
    excludeProducts(products) {
      this.excludeCoverageProducts({ products })
      this.searchProducts()
    },
  },
}
</script>

<style></style>
